import { useState, useRef, CSSProperties } from "react";
import { FaqsContent, Tooltip } from "../components";
import { useDesktop } from "../hooks";
import { AnimatePresence, motion } from "framer-motion";
import { StyledLink } from "../utils/button";
import { HomeData } from "../data/homecourses";

import {
  BsFillArrowRightSquareFill,
  BsFillArrowLeftSquareFill,
} from "react-icons/bs";
import { IoMdCloseCircle } from "react-icons/io";

import workingLadyDesktop from "../assets/working-lady-desktop.svg";
import workingLady from "../assets/WorkplaceLady.png";
import workingGuy from "../assets/WorkplaceGuy.svg";
import accessImg from "../assets/accessImg.png";
import desktopaccessImg from "../assets/desktopaccessImg.png";
import chooseImg from "../assets/chooseImg.svg";
import mobileTestimonial from "../assets/mobile testimonial.png";
import desktopTestimonial from "../assets/desktopTestimonial.svg";
import play from "../assets/play.png";
import "../styles/home.css";

const Home = () => {
  const [scrollX, setscrollX] = useState(0); // For detecting start scroll postion
  const [linescrollX, setlinescrollX] = useState(0);
  const [lineStyle, setlineStyle] = useState({
    left: "0px",
    position: "relative",
  } as CSSProperties);
  let scrl = useRef<HTMLDivElement>(null);
  const [show, setShow] = useState(true);
  const [isToolTipMounted, setIsToolTipMounted] = useState(true); //for detecting if tooltip is mounted
  const [content, setContent] = useState({
    title: "",
    data: "",
    list1: "",
    list2: "",
    list3: "",
  });

  const homecourses = HomeData.map((course, i) => (
    <div
      key={i}
      className="home-courses-card"
    >
      <img
        src={course.banner}
        alt="banner"
      />
      <h4>{course.title}</h4>
      <div>
        <p>{course.duration}</p>
        <p
          data-tip
          data-for="global"
          onMouseEnter={() => {
            setContent(course);
            setIsToolTipMounted(true);
          }}
        >
          {course.viewsCount}
        </p>
      </div>
    </div>
  ));

  const slide = (shift: number, lineShift: number) => {
    if (null !== scrl.current) {
      const scrollLength = Math.round(
        scrl.current.scrollLeft + scrl.current.offsetWidth,
      );
      scrl.current.scrollLeft += shift;
      setscrollX(scrollX + shift);
      setlinescrollX(linescrollX + lineShift);

      // check if scrolling has ended

      if (
        scrollLength === scrl.current.scrollWidth ||
        scrl.current.scrollLeft === 0
      ) {
        setlinescrollX(0);
        setlineStyle((prevStyle) => {
          return {
            ...prevStyle,
            left: "110px",
            position: "static",
          };
        });
      } else {
        setlineStyle((prevStyle) => {
          return {
            ...prevStyle,
            left: `${linescrollX}px`,
            position: "relative",
          };
        });
      }
    }
  };

  const scrollCheck = () => {
    if (null !== scrl.current) {
      setscrollX(scrl.current.scrollLeft);
    }
  };

  function righthandleClick() {
    slide(250, 22);
  }
  function lefthandleClick() {
    slide(-250, -22);
  }

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0.4 }}
      transition={{ duration: 0.5 }}
      className="home"
    >
      <section className="hero">
        <div>
          <h2>
            Best Online <br className="learning-hero" /> Learning{" "}
            <br className="video-hub" /> <span>Video Hub</span>
          </h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi velit{" "}
            <br /> nulla pretium ultrices enim at{" "}
            <span className="show-sit">
              Sit egestas aliquet sodales amet, <br />
              sed nam maecenas.
            </span>
          </p>
          <StyledLink
            to="/courses"
            className="btn hero_btn explore"
          >
            Explore Courses
          </StyledLink>
        </div>
        <div>
          <img
            src={useDesktop() >= 1024 ? workingLadyDesktop : workingLady}
            alt="Working Lady"
            className="working-lady"
          />
        </div>
      </section>
      <section className="know-more">
        <div className="know-more-header">
          <h3>
            Know more about Vidom? <br /> Learning Platform
          </h3>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi velit
            nulla pretium ultrices enim at. Sit egestas aliquet sodales amet,
            sed nam maecenas.
          </p>
          <div>
            <div>
              <p>50K +</p>
              <p>
                Students <br /> Learning
              </p>
            </div>
            <div>
              <p>250+</p>
              <p>
                Students <br /> Learning
              </p>
            </div>
            <div>
              <p>50+</p>
              <p>
                Daily <br /> Signups
              </p>
            </div>
          </div>
          <StyledLink
            to="/courses"
            className="btn know explore"
          >
            Explore Courses
          </StyledLink>
        </div>
        <div>
          <img
            src={workingGuy}
            className="working-guy"
            alt="working-guy"
          />
        </div>
      </section>

      <section className="top-rated">
        <h3>
          See Our Top Rated <br /> Courses
        </h3>

        <div
          className="home-courses-container"
          ref={scrl}
          onScroll={scrollCheck}
        >
          {homecourses}
          {homecourses}
        </div>

        {useDesktop() >= 1024 && (
          <div className="home-courses-scrolleffect">
            <BsFillArrowLeftSquareFill
              onClick={lefthandleClick}
              style={{
                fontSize: "2em",
                color: "var(--vidomCustomBlue)",
                marginLeft: "1em",
                cursor: "pointer",
                opacity: scrollX <= 0 ? 0.3 : 1,
              }}
              className="suggested-courses-arrow-left"
            />
            <div>
              <div
                className="line-scroller"
                style={lineStyle}
              ></div>
            </div>

            <BsFillArrowRightSquareFill
              onClick={righthandleClick}
              style={{
                fontSize: "2em",
                color: "var(--vidomCustomBlue)",
                cursor: "pointer",
                marginLeft: "1em",
              }}
              className="suggested-courses-arrow-right"
            />
          </div>
        )}
      </section>

      <section className="access">
        <div>
          <h3>
            Get access to all <br /> courses now from <span>$50</span>
          </h3>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi <br />{" "}
            velit nulla pretium ultrices enim at.{" "}
            <span>
              Sit egestas aliquet <br /> sodales amet, sed nam maecenas.
            </span>{" "}
          </p>
          <StyledLink
            to="/plans"
            className="plans hero_btn btn"
          >
            Click Here to Start
          </StyledLink>
        </div>
        <div>
          {/* should be a video tag  */}
          <img
            src={useDesktop() >= 1024 ? desktopaccessImg : accessImg}
            alt="woman on her phone"
            className="phone-woman"
          />
          <img
            src={play}
            alt="play"
            className="play"
          />
        </div>
      </section>

      <section className="choose">
        <h3>
          Why Choose <span>Vidom?</span>
        </h3>
        <div>
          <div>
            <img
              src={chooseImg}
              alt="choose"
            />
            <h4>Practical Learning</h4>
            <p>
              Videos tailored to real world <br /> learning and practice
            </p>
          </div>
          <div>
            <img
              src={chooseImg}
              alt="choose"
            />
            <h4>
              Unlimited Access <br /> Purchased Videos
            </h4>
            <p>Don't worry, you will always have access to your paid videos</p>
          </div>
          <div>
            <img
              src={chooseImg}
              alt="choose"
            />
            <h4>
              Videos By Industry <br /> Experts
            </h4>
            <p>
              An opportunity to learn with <br /> industry experts
            </p>
          </div>
          <div>
            <img
              src={chooseImg}
              alt="choose"
            />
            <h4>Scheduled Learning</h4>
            <p>
              Learn at whatever time <br /> and place that suits you
            </p>
          </div>
          <div>
            <img
              src={chooseImg}
              alt="choose"
            />
            <h4>
              Premium Subscription <br /> With Unlimited Access to Thousands Of
              Videos
            </h4>
            <p>Don't worry, you will always have access to your paid videos</p>
          </div>
          <div>
            <img
              src={chooseImg}
              alt="choose"
            />
            <h4>Course Accessibility</h4>
            <p>
              Select a suitable course from the <br /> vast area of other
              cousers
            </p>
          </div>
        </div>
      </section>
      <section className="testimonials">
        <div>
          <h4>What Our Clients Say</h4>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi velit
            nulla pretium ultrices enim at. Sit egestas aliquet sodales amet,
            sed nam maecenas.
          </p>
          {useDesktop() >= 1024 && (
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi velit
              nulla pretium ultrices enim at. Sit egestas aliquet sodales amet,
              sed nam maecenas.
            </p>
          )}
          <p className="chike">Chike Anam</p>
          <p>Product Designer @Facebook</p>
        </div>
        <div>
          <img
            src={useDesktop() >= 1024 ? desktopTestimonial : mobileTestimonial}
            alt="testimonial"
          />
        </div>
      </section>
      <AnimatePresence>
        {useDesktop() >= 1024 && show && (
          <motion.section
            className="home-modal-popup"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0.4 }}
            transition={{ duration: 0.5 }}
          >
            <div>
              <IoMdCloseCircle
                style={{ color: "#fff", fontSize: "2.3em", cursor: "pointer" }}
                onClick={() => setShow(!show)}
              />
            </div>
            <div>
              <h3>
                Get access to all <br />
                courses now from $50
              </h3>
              <StyledLink to="/courses">Click Here to Start</StyledLink>
            </div>
          </motion.section>
        )}
      </AnimatePresence>

      <Tooltip
        isToolTipMounted={isToolTipMounted}
        content={content}
      />

      <aside className="faqs">
        <h4>FAQs</h4>
        <div>
          <FaqsContent />
        </div>
      </aside>
    </motion.main>
  );
};

export default Home;
